import css from 'styled-jsx/css';

export default css`.consent {
  margin-bottom: 30px; }
  .consent ol {
    width: 95%;
    max-width: 650px;
    margin: auto;
    list-style-type: decimal;
    padding-inline-start: 25px; }
    .consent ol li {
      margin-bottom: 10px;
      line-height: 1.2em; }
`